import { RIBBON_ID } from '../ribbon-base/ribbon-constants';
import { RibbonItemSize } from '@syncfusion/ej2-ribbon';
import { LineSpacingHelper } from '../../helper/line-spacing-helper';
// Line spacing constants
export const LINE_SPACING_ID = '_line_spacing';
/**
 * LineSpacingGroup class for handling line spacing operations in Document Editor ribbon
 * @private
 */
export class LineSpacingGroup {
    /**
     * Constructor for LineSpacingGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        // Property to track the last applied line spacing value
        this.appliedLineSpacing = '1';
        this.container = container;
        this.ribbonId = this.container.element.id + RIBBON_ID;
        this.localObj = this.container.localObj;
    }
    get documentEditor() {
        return this.container.documentEditor;
    }
    /**
     * Get the line spacing dropdown item configuration
     * @returns {RibbonItemModel} - Line spacing dropdown item configuration
     * @private
     */
    getLineSpacingItem() {
        const id = this.ribbonId;
        return {
            type: 'DropDown',
            keyTip: 'K',
            allowedSizes: RibbonItemSize.Small,
            dropDownSettings: {
                iconCss: 'e-de-ctnr-linespacing e-icons',
                content: this.localObj.getConstant('Line spacing'),
                items: LineSpacingHelper.getLineSpacingItems(this.localObj),
                select: (args) => {
                    this.lineSpacingAction(args);
                },
                beforeItemRender: (args) => {
                    LineSpacingHelper.customizeLineSpacingItem(args, this.appliedLineSpacing);
                }
            },
            id: id + LINE_SPACING_ID,
            ribbonTooltipSettings: { content: this.localObj.getConstant('Line spacing') }
        };
    }
    /**
     * Set the line spacing based on current paragraph format
     * @returns {void}
     * @private
     */
    setLineSpacing() {
        this.appliedLineSpacing = LineSpacingHelper.getCurrentLineSpacing(this.documentEditor, this.localObj);
    }
    lineSpacingAction(args) {
        const appliedSpacing = { value: this.appliedLineSpacing };
        LineSpacingHelper.applyLineSpacing(this.documentEditor, args.item.text, appliedSpacing, this.localObj);
        this.appliedLineSpacing = appliedSpacing.value;
    }
}
